import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import bind from 'bind-decorator';
import {ChargePeriod} from '@mintdata-wsp/common/state/ui/storefront/ChargePeriod';
import {Column} from '@mintdata-wsp/wsp/ui/components/forms/Column';
import {Row} from '@mintdata-wsp/wsp/ui/components/forms/Row';
import {ButtonStyle, WSPButton} from '@mintdata-wsp/wsp/ui/components/general/WSPButton';

const styles = require('./ChargePeriodSwitcher.less');
const cx = classnames.bind(styles);

export class ChargePeriodSwitcherProps
{
    className:string;
}

@observer
export class ChargePeriodSwitcher extends React.Component<ChargePeriodSwitcherProps, any>
{
    @bind
    _onMonthlySelected(e:any)
    {
        const controller = controllers.ui.productSelection;
        controller.selectChargePeriod(ChargePeriod.Month);
    }

    @bind
    _onAnnuallySelected(e:any)
    {
        const controller = controllers.ui.productSelection;
        controller.selectChargePeriod(ChargePeriod.Annual);
    }

    render()
    {
        const {className} = this.props;
        const controller = controllers.ui.productSelection;

        const isMonthlySelected = controller.isChargePeriodSelected(ChargePeriod.Month);
        const isAnnuallySelected = controller.isChargePeriodSelected(ChargePeriod.Annual);

        return  <Column className={cx('chargePeriodSwitcher', className)}>

                    <Row className={cx('buttonsRow')}>
                        <WSPButton className={cx('chargePeriodButton', 'firstButton', {selectedButton: isMonthlySelected})}
                                   onClick={this._onMonthlySelected}
                                   isIntentStyleDisabled={true}
                                   caption={'Monthly'}
                                   style={ButtonStyle.SimpleSecondary}
                        />

                        <WSPButton className={cx('chargePeriodButton', 'lastButton', {selectedButton: isAnnuallySelected})}
                                   onClick={this._onAnnuallySelected}
                                   isIntentStyleDisabled={true}
                                   caption={'Annually'}
                                   style={ButtonStyle.Simple}/>
                    </Row>
                    <Row className={cx('annualSavingsRow')}>
                        Save 20%
                    </Row>

                </Column>;
    }
}
